import {
  extendADNDDataSource,
  DEFAULT_PROPS as ADNDDataSource_DEFAULT_PROPS,
  PRIVATE as ADNDDataSource_PRIVATE
} from './ADNDDataSource'
import { getScrollX, getScrollY } from '../ADNDHelpers'
import ADND from '../ADND'
import { updateState } from '../ADNDState'
import ADNDDragLayer from '../layers/ADNDDragLayer'
import ADNDTargetsLayer from '../layers/ADNDTargetsLayer'

function DEFAULT_PROPS() {
  return {
    ...ADNDDataSource_DEFAULT_PROPS(),
    dragLayer: null,
    dragLayerClassName: null,
    finalizeDragLayerContentHandler: null,
    lockX: false,
    lockY: false,
    hitShift: true,
    parent: 0
  }
}

const PRIVATE = {
  doStart(event) {
    if (null == this.props.dragLayer && null != this.props.node) {
      const cursorX = event.pageX || event.clientX
      const cursorY = event.pageY || event.clientY

      let node = this.props.node
      for (let i = 0; i < this.props.parent; i++) node = node.parentNode
      if ('undefined' !== typeof this.props.child) node = node.childNodes[this.props.child]

      this.props.dragLayer = ADNDDragLayer()
      this.props.dragLayer.start(event)
      this.props.dragLayer.cloneContent({
        cursorX,
        cursorY,
        node,
        lockX: this.props.lockX,
        lockY: this.props.lockY,
        className: this.props.dragLayerClassName,
        finalizeContent: this.props.finalizeDragLayerContentHandler
      })
      ADND().addLayer(this.props.dragLayer)

      if (this.props.lockX) {
        ADNDTargetsLayer().lockX(cursorX)
      }
      if (this.props.lockY) {
        ADNDTargetsLayer().lockY(cursorY)
      }

      if (false !== this.props.hitShift) {
        if (true === this.props.hitShift && this.props.rect && null != this.props.rect.top) {
          ADNDTargetsLayer().hitShift(0, this.props.rect.top - cursorY)
        } else if ('object' === typeof this.props.hitShift) {
          ADNDTargetsLayer().hitShift(this.props.hitShift.x, this.props.hitShift.y)
        }
      }

      updateState(state => {
        state.operation.type = 'move'
        state.operation.enableMove = true
        state.operation.enableClone = false
        return state
      })

      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'copyMove'
      }
    }
    return ADNDDataSource_PRIVATE.doStart.call(this, event)
  },
  doEnd(event) {
    ADNDTargetsLayer().hitShift(0, 0)
    if (null != this.props.dragLayer) {
      this.props.dragLayer.stop(event)
      ADND().removeLayer(this.props.dragLayer)
      this.props.dragLayer = null
    }
    return ADNDDataSource_PRIVATE.doEnd.call(this, event)
  },
  fetchRect(scrollX = getScrollX(), scrollY = getScrollY()) {
    if (null != this.props.node) {
      const rect = this.props.node.getBoundingClientRect()
      this.props.rect = {
        left: rect.left + scrollX,
        right: rect.right + scrollX,
        top: rect.top + scrollY,
        bottom: rect.bottom + scrollY,
        width: rect.width || rect.right - rect.left,
        height: rect.height || rect.bottom - rect.top
      }
    } else {
      this.props.rect = null
    }
    return this.PRIVATE
  }
}

const PUBLIC = {
  getDragLayerClassName() {
    return this.props.dragLayerClassName
  },
  setDragLayerClassName(className) {
    this.props.dragLayerClassName = className
  },
  onFinalizeDragLayerContent(finalizeDragLayerContentHandler) {
    if ('function' == typeof finalizeDragLayerContentHandler) {
      this.props.finalizeDragLayerContentHandler = finalizeDragLayerContentHandler
    }
    return this.PUBLIC
  }
}

export default function ADNDDraggableDataSource(props = {}) {
  const ADNDDraggableDataSource = extendADNDDataSource(props, DEFAULT_PROPS())

  ADNDDraggableDataSource.PRIVATE.doStart = PRIVATE.doStart.bind(ADNDDraggableDataSource)
  ADNDDraggableDataSource.PRIVATE.doEnd = PRIVATE.doEnd.bind(ADNDDraggableDataSource)
  ADNDDraggableDataSource.PRIVATE.fetchRect = PRIVATE.fetchRect.bind(ADNDDraggableDataSource)

  ADNDDraggableDataSource.PUBLIC.getDragLayerClassName = PUBLIC.getDragLayerClassName.bind(ADNDDraggableDataSource)
  ADNDDraggableDataSource.PUBLIC.setDragLayerClassName = PUBLIC.setDragLayerClassName.bind(ADNDDraggableDataSource)
  ADNDDraggableDataSource.PUBLIC.onFinalizeDragLayerContent =
    PUBLIC.onFinalizeDragLayerContent.bind(ADNDDraggableDataSource)

  return ADNDDraggableDataSource.PUBLIC
}
